import ApiServer from '@/utils/api/ApiServer.js'
import { createResourceUrl, sasNeedsRefresh } from '@/utils/SasHelpers.js'
import { BlobServiceClient } from '@azure/storage-blob'

const CUSTOM_LAYERS_ENDPOINT = 'companyInfo/blobinfo/customlayers'
const CUSTOM_LAYER_EXTENSION = '.geojson'

export const CUSTOM_LAYER_PALETTE = ['#E53935', '#1E88E5', '#43A047', '#FB8C00', '#8E24AA', '#00ACC1', '#FDD835', '#F06292']
export const CUSTOM_LAYER_DEFAULT_OPACITY = 0.35

let capsule = null
let capsulePromise = null
const featureCache = new Map()

function getCapsule () {
  if (capsule && !sasNeedsRefresh(capsule.blobSasUri)) return Promise.resolve(capsule)
  if (!capsulePromise) {
    capsulePromise = ApiServer.get(CUSTOM_LAYERS_ENDPOINT)
      .then(res => {
        const next = res && res.data && res.data[0]
        if (!next || !next.blobSasUri) throw new Error('No custom layers SAS capsule returned')
        capsule = next
        return next
      })
      .finally(() => { capsulePromise = null })
  }
  return capsulePromise
}

export function layerLabel (name) {
  return name.toLowerCase().endsWith(CUSTOM_LAYER_EXTENSION)
    ? name.slice(0, -CUSTOM_LAYER_EXTENSION.length)
    : name
}

export async function listCustomLayers () {
  const cap = await getCapsule()
  const containerClient = new BlobServiceClient(cap.blobSasUri).getContainerClient(cap.container)
  const layers = []
  for await (const blob of containerClient.listBlobsFlat()) {
    if (!blob.name.toLowerCase().endsWith(CUSTOM_LAYER_EXTENSION)) continue
    layers.push({
      name: blob.name,
      sizeBytes: blob.properties.contentLength ?? 0,
      lastModified: blob.properties.lastModified,
      eTag: blob.properties.etag ?? ''
    })
  }
  return layers
}

export async function fetchCustomLayerFeatures (layer, signal) {
  const cached = featureCache.get(layer.name)
  if (cached && cached.eTag === layer.eTag) return cached.features
  const cap = await getCapsule()
  const res = await fetch(createResourceUrl(cap.blobSasUri, cap.container, encodeURIComponent(layer.name)), { signal })
  if (!res.ok) throw new Error(`Custom layer ${layer.name} -> ${res.status}`)
  const geojson = await res.json()
  const features = geojson?.type === 'FeatureCollection'
    ? (geojson.features ?? [])
    : geojson?.type === 'Feature' ? [geojson] : []
  featureCache.set(layer.name, { eTag: layer.eTag, features })
  return features
}
